// Auto-generated from Matterport OG metadata, then curated.
// To refresh: re-run the fetch script and regenerate this file.

export type MatterportCategory = 'main' | 'guest-room' | 'meeting-space';

export interface MatterportTour {
  id: string;            // Matterport model ID
  name: string;          // Short display name
  category: MatterportCategory;
  thumbnail: string;     // Matterport-hosted preview image
  description?: string;
  address?: string;
}

const thumb = (id: string) => `https://my.matterport.com/api/v2/player/models/${id}/thumb/`;

export const matterportTours: MatterportTour[] = [
  // Main hero
  {
    id: 'bCmpMF4uC9w',
    name: 'Cleveland Marriott Downtown',
    category: 'main',
    thumbnail: thumb('bCmpMF4uC9w'),
    description: 'Full property tour of the Cleveland Marriott Downtown.',
  },

  // Guest Rooms
  { id: 'AeGQ9xcbgmP', name: 'Room 711', category: 'guest-room', thumbnail: thumb('AeGQ9xcbgmP'), address: '1360 West Mall Drive, Cleveland, OH 44114', description: 'Spacious 280 sq. ft. room with double beds, accent chair, work area, and city views.' },
  { id: 'v6vjYD5xF9N', name: 'Room 710', category: 'guest-room', thumbnail: thumb('v6vjYD5xF9N'), address: '300 St Clair Ave NE, Cleveland, OH 44113' },
  { id: 'BtzzZCQrN72', name: 'Room 604', category: 'guest-room', thumbnail: thumb('BtzzZCQrN72'), address: '1360 W Mall Dr, Cleveland, OH 44114' },
  { id: 'Rntm8Pzw83X', name: 'Room 520', category: 'guest-room', thumbnail: thumb('Rntm8Pzw83X'), address: '100 St Clair Ave NE, Cleveland, OH 44114' },
  { id: 'eZtpij5tdhE', name: 'Room 2502', category: 'guest-room', thumbnail: thumb('eZtpij5tdhE'), address: '300 St Clair Ave NE, Cleveland, OH 44113' },
  { id: 'WRC9T4uEnYU', name: 'Room 415', category: 'guest-room', thumbnail: thumb('WRC9T4uEnYU') },
  { id: 'QkA2H15fQXm', name: 'Room 507', category: 'guest-room', thumbnail: thumb('QkA2H15fQXm') },
  { id: '99ET5NkSMLi', name: 'Room 510', category: 'guest-room', thumbnail: thumb('99ET5NkSMLi') },
  { id: 'htmKpxDEmC3', name: 'Room 609', category: 'guest-room', thumbnail: thumb('htmKpxDEmC3') },
  { id: 'PmTyX8UVBcS', name: 'Room 1905', category: 'guest-room', thumbnail: thumb('PmTyX8UVBcS') },
  { id: '38WiSJh4fmt', name: 'Room 2009', category: 'guest-room', thumbnail: thumb('38WiSJh4fmt') },

  // Meeting Spaces & Amenities
  { id: 'WeEdRaj9WQu', name: 'St Clair Ballroom', category: 'meeting-space', thumbnail: thumb('WeEdRaj9WQu'), description: 'Grand ballroom for large events and conferences.' },
  { id: 'KMQwW6azSBm', name: 'Private Function Room', category: 'meeting-space', thumbnail: thumb('KMQwW6azSBm'), description: 'Elegant private meeting space with sophisticated seating.' },
  { id: 'TXYhpibZi2C', name: 'Il Venetian Restaurant', category: 'meeting-space', thumbnail: thumb('TXYhpibZi2C'), description: 'Luxurious 2,690 sq. ft. restaurant with elegant dining areas, bar, and lounge.' },
  { id: 'L5XfGgfkrMy', name: 'Marble Room Steaks & Raw Bar', category: 'meeting-space', thumbnail: thumb('L5XfGgfkrMy'), description: 'Historic 23,350 sq. ft. venue across 3 floors with grand architecture.' },
  { id: 'y9WgRoPheqQ', name: 'Ascend Spa', category: 'meeting-space', thumbnail: thumb('y9WgRoPheqQ'), description: 'Full-service on-site spa amenity.' },
  { id: 'WRQkyQqhy56', name: 'Ascend Fitness Center', category: 'meeting-space', thumbnail: thumb('WRQkyQqhy56'), description: 'Modern 7,600 sq. ft. fitness center with cardio, strength, and group exercise spaces.' },
];

export const guestRoomTours = matterportTours.filter((t) => t.category === 'guest-room');
export const meetingSpaceTours = matterportTours.filter((t) => t.category === 'meeting-space');
export const mainTour = matterportTours.find((t) => t.category === 'main')!;
